import * as React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import ModalDialog from 'components/ui/modal-dialog'
import { getSelectionReturnPath } from 'utils/routing'

function MergeDisable() {
  const navigate = useNavigate()
  const location = useLocation()

  const onConfirm = React.useCallback(() => {
    navigate(getSelectionReturnPath(location.pathname))
  }, [navigate, location.pathname])

  return (
    <ModalDialog
      title="Sorry!"
      primaryAction={{
        caption: 'OK',
        onClick: onConfirm,
      }}
    >
      You can’t merge files of different types (i.e. audio with video, documents
      with audio).
    </ModalDialog>
  )
}

export default MergeDisable
